import { TAnuncio, TConcessionaria, TGrupoConcessionaria } from '../../services';
import { asset, logoUrl } from '../../config/tenant';
import { imagesBaseUrl } from '../constants';

const semFoto = () => asset('/images/sem_foto.png');

export const getImageUrl = {
	anuncios: (offerId: number, imageFile?: string) => {
		if (!imageFile) {
			return semFoto();
		}

		if (process.env.NODE_ENV === 'development') {
			return imageFile;
		}

		return `${imagesBaseUrl.anuncios}/${offerId}/${imageFile}`;
	},
	anunciosCapa: (offerData?: TAnuncio) => {
		const imageFile =
			offerData?.anuncioFotos.find((image) => image.tagCapa === '1')?.linkFoto ||
			offerData?.anuncioFotos[0]?.linkFoto;

		if (!imageFile || !offerData) {
			return semFoto();
		}

		if (process.env.NODE_ENV === 'development') {
			return imageFile;
		}

		return `${imagesBaseUrl.anuncios}/${offerData.id}/${imageFile}`;
	},
	concessionaria: (dealer?: TConcessionaria) => {
		const imageFile = dealer?.logotipo;

		if (!imageFile) {
			return semFoto();
		}


		if (process.env.NODE_ENV === 'development') {
			return `${imagesBaseUrl.concessionaria}/${dealer.id}/${imageFile}`;
		}

		return `${imagesBaseUrl.concessionaria}/${dealer.id}/${imageFile}`;
	},
		grupoConcessionaria: (dealerGroup?: TGrupoConcessionaria) => {
		const imageFile = dealerGroup?.logotipo;

		if (!imageFile) {
			return semFoto();
		}

		if (imageFile.startsWith('http')) {
			return imageFile;
		}

		// sempre tenta primeiro a pasta grupoConcessionaria
		return `${imagesBaseUrl.grupoConcessionaria}/${dealerGroup.id}/${encodeURIComponent(imageFile)}`;
		},

	logoPadrao: () => {
		return logoUrl();
	},
	laudoTecnico: (offerId: number, pdfFile?: string) => {
		if (!pdfFile) {
			return '';
		}

		if (process.env.NODE_ENV === 'development') {
			return pdfFile;
		}
		
		if (pdfFile.includes("http://") || pdfFile.includes("https://")) {
			return pdfFile;
		} else {
			return `${imagesBaseUrl.anuncios}/${offerId}/${pdfFile}`;
		}
	},
};
